module.exports = __webpack_public_path__ + "img/selected.47e979ea.svg";